module.exports = __webpack_public_path__ + "media/images/carte-rec-visita-premilinar-faf071d15254b9173b5a2be9fdfcbcd9.png";